import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { ITableColumn } from './tabela-form.model';
import { sortSelectOptions } from '../../utils/sort-select-options';

@Component({
  selector: 'app-tabela-form',
  templateUrl: './tabela-form.component.html',
  styleUrls: ['./tabela-form.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TabelaFormComponent),
      multi: true
    }
  ]
})
export class TabelaFormComponent implements OnInit {
  @Input() data: any[] = [];
  @Input() columns: ITableColumn[] = [];
  @Output() ngModelChange: EventEmitter<any> = new EventEmitter();
  selectedItem: any;

  onSelectChange(value: any, item: any) {
    const body = {
      value: value,
      item: item
    };
    this.ngModelChange.emit(body);
  }

  sortedColumnOptions(options: { label?: string; name?: string; value: any }[] | undefined) {
    return sortSelectOptions(options ?? []);
  }

  toggleAtivo(item: any) {
    item.ativo = !item.ativo;
    this.selectedItem = item;
  }

  constructor() {}

  ngOnInit() {}
}
